import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdAdminPanelSettings, MdDashboard, MdContentCopy } from "react-icons/md";
import { IoIosPerson, IoMdArrowDropdown } from "react-icons/io";
import { PiStudentBold } from "react-icons/pi";
import { RxDropdownMenu } from "react-icons/rx";
import UpdateProfile from '../AdminPanel/AdminPanel/UpdateProfile';
import ChangePassword from '../AdminPanel/AdminPanel/ChangePassword';
import Logout from '../AdminPanel/AdminPanel/Logout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBlogger } from "@fortawesome/free-brands-svg-icons";

const HrSidebar = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDown, setDown] = useState(false);
  const [profileDown, setProfileDown] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCollabDropdownOpen, setIsCollabDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showPopupCp, setShowPopupCp] = useState(false);
  const [showPopupUp, setShowPopupUp] = useState(false);
  const [showPopupL, setShowPopupL] = useState(false);

  const profilePicDown = () => {
    setProfileDown(!profileDown);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleStudentManagementClick = () => {
    setDown(!isDown);
  };

  const handleCollaborationClick = () => {
    setIsCollabDropdownOpen(!isCollabDropdownOpen);
  };

  const handleDashboardClick = () => {
    navigate("/hrDashboard");
  };

  const navigateToRoleManagement = () => {
    navigate("/RoleManagementHR");
  };

  const navigateToAreaManagement = () => {
    navigate("/allStateHR");
  };

  const navigateToEnrolledStudents = () => {
    navigate("/enrolledstudents");
  };

  const navigateToQualifiedStudents = () => {
    navigate("/qualifiedstudents");
  };

  const navigateToCollaboration = () => {
    navigate("/collaborationbackend");
  };
  const navigateToCollaborationn = () => {
    navigate("/collaborationbackendd");
  };

  const HandlepopupCp = () => setShowPopupCp(true);
  const HandlepopupUp = () => setShowPopupUp(true);
  const HandlepopupL = () => setShowPopupL(true);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      <button
        data-drawer-target="sidebar-multi-level-sidebar"
        data-drawer-toggle="sidebar-multi-level-sidebar"
        aria-controls="sidebar-multi-level-sidebar"
        type="button"
        className="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        onClick={handleDropdownToggle}
      >
        <span className="sr-only">Open sidebar</span>
        <RxDropdownMenu className="w-8 h-8" />
      </button>

      <aside
        id="sidebar-multi-level-sidebar"
        ref={dropdownRef}
        className={`fixed top-0 ml-[0px] z-40 w-64 h-screen transition-transform ${isDropdownOpen ? "" : "-translate-x-full sm:translate-x-0 pt-24"}`}
        aria-label="Sidebar"
      >

    <div className="h-full px-3 py-4 overflow-y-auto bg-custom-color dark:bg-gray-800 rounded-tr-[100px]">
          <ul className="space-y-2 font-medium">
       <button
              type="button"
              className="flex items-center w-64 p-2 text-base text-white bg-custom-color transition duration-75 rounded-lg group hover:bg-gray-100 hover:text-gray-900 dark:text-white dark:hover:bg-gray-700 mt-[-30px] rounded-bl-[50px] ml-[-50px] bg-white rounded-tr-[70px]"
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
              onClick={profilePicDown}
            >
              <img src="/hr_profile.PNG" alt="" style={{ width: "50px", height: "50px", backgroundColor: "black", borderRadius: "50%", marginLeft: "20px" }} />
              <p style={{ color: "black", marginTop: "-40px", paddingLeft: "10px" }} className="dropdown-toggle pt-[50px] font-bold">
                HR
              </p>
              <IoMdArrowDropdown className="w-5 h-5 text-black" />
            </button>
            <ul
              id="dropdown-example"
              className={`py-2 space-y-2 ${profileDown ? "" : "hidden"}`}
            >
              <a href="#" onClick={HandlepopupUp} className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 whitespace-nowrap ml-[-70px] no-underline">
                Update profile 
              </a>
              {
              showPopupUp &&(
                <UpdateProfile onClose={() => setShowPopupUp(false)}/>
              )
            }
              <a href="#" onClick={HandlepopupCp} className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 whitespace-nowrap ml-[-70px] no-underline">
                Change Password
              </a>
              {
              showPopupCp &&(
                <ChangePassword onClose={() => setShowPopupCp(false)}/>
              )
            }
              <a href="#" onClick={HandlepopupL} className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 whitespace-nowrap ml-[-70px] no-underline">
                Logout
              </a>
              {
              showPopupL &&(
                <Logout onClose={() => setShowPopupL(false)}/>
              )
            }
            </ul>

            <a href="#" onClick={handleDashboardClick} className="flex items-center p-2 text-white rounded-lg hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 pl-[15px] no-underline">
              <MdDashboard className="ml-[-60px]" />
              <span className="ms-3 ml-[-20px]">Dashboard</span>
            </a>

            <button type="button" onClick={toggleDropdown} className="flex items-center w-full p-2 text-base text-white bg-custom-color transition duration-75 rounded-lg group hover:bg-gray-100 hover:text-gray-900 dark:text-white dark:hover:bg-gray-700 pl-[15px]" aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example">
                <PiStudentBold className="ml-[-60px] cursor-pointer" />
              <span className="ms-3 ml-[-20px]">Admin Master</span>
              <IoMdArrowDropdown className="w-5 h-5" />
            </button>
            <ul className={`py-2 space-y-2 ${isOpen ? "" : "hidden"}`}>
              <a href="#" onClick={navigateToRoleManagement} className="flex items-center w-full p-1 text-white rounded-lg hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 ml-[-70px] pl-11 no-underline">
                Role Management
              </a>
              <a href="#" onClick={navigateToAreaManagement} className="flex items-center w-full p-1 text-white rounded-lg hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 ml-[-70px] pl-11 no-underline">
                Master Modules
              </a>
            </ul>

            <a href="/eventmanagementHR" className="flex items-center p-2 text-white rounded-lg hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 pl-[15px] no-underline">
              <IoIosPerson className="ml-[-60px]" />
              <span className="ms-3 ml-[-20px]">Event Management</span>
            </a>
            <button
              type="button"
              className="flex items-center w-full p-2 text-base text-white bg-custom-color transition duration-75 rounded-lg group hover:bg-gray-100 hover:text-gray-900 dark:text-white dark:hover:bg-gray-700 pl-[15px]"
              aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example"
              onClick={handleStudentManagementClick}
            >
              <PiStudentBold className="ml-[-60px] cursor-pointer" />
              <span className="ms-3 ml-[-20px] cursor-pointer">Student Management</span>
              <IoMdArrowDropdown className="w-5 h-5" />
            </button>
            <ul id="dropdown-example" className={`py-2 space-y-2 ${isDown ? "" : "hidden"}`}>
              <a href="#" onClick={navigateToEnrolledStudents} className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 whitespace-nowrap ml-[-70px] no-underline">
                Enrolled Students
              </a>
              <a href="#" onClick={navigateToQualifiedStudents} className="flex items-center w-full p-2 text-white transition duration-75 rounded-lg pl-11 group hover:text-gray-900 hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700 whitespace-nowrap ml-[-70px] no-underline">
                Qualified Students
              </a>
            </ul>

            {/* Collaboration with dropdown */}
            <button type="button" onClick={handleCollaborationClick} className="flex items-center w-full p-2 text-base text-white bg-custom-color transition duration-75 rounded-lg group hover:bg-gray-100 hover:text-gray-900 dark:text-white dark:hover:bg-gray-700 pl-[15px]" aria-controls="dropdown-example"
              data-collapse-toggle="dropdown-example">
              <PiStudentBold className="ml-[-60px] cursor-pointer" />
              <span className="ms-3 ml-[-20px]">Collaboration</span>
              <IoMdArrowDropdown className="w-5 h-5" />
            </button>
            <ul className={`py-2 space-y-2 ${isCollabDropdownOpen ? "" : "hidden"}`}>
              <a href="#" onClick={navigateToCollaborationn} className="flex items-center w-full p-2 text-white rounded-lg hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 ml-[-70px] pl-11 no-underline">
                Project Collaboration
              </a>
            </ul>
            <ul className={`py-2 space-y-2 ${isCollabDropdownOpen ? "" : "hidden"}`}>
              <a href="#" onClick={navigateToCollaboration} className="flex items-center w-full p-2 text-white rounded-lg hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 ml-[-70px] pl-11 no-underline">
                Collaborators
              </a>
            </ul>

            <a href="/blogdetails" className="flex items-center p-2 text-white rounded-lg hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 pl-[15px] no-underline">
              <FontAwesomeIcon icon={faBlogger} className="ml-[-60px]" />
              <span className="ms-3 ml-[-20px]">Blog</span>
            </a>

          </ul>
        </div>
      </aside>
    </div>
  );
};

export default HrSidebar;
